module.exports = __webpack_public_path__ + "static/img/zhong_name.11273a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brandLanshu/zhong_name.png
// module id = cD/J
// module chunks = 0